<div class="none-login-footer" [class.none-login-footer--mobile]="isMobile">
  <div class="none-login-footer__title">運営会社</div>
  <div class="none-login-footer__sub-title">
    Spreadyは「やりたいに出会い続ける世界をつくる」ことをミッションに掲げ、<br>
  人と人、人と組織の新しい出会いを社会に実装するセレンディピティカンパニーです。
  </div>
  <div class="none-login-footer__services" [class.none-login-footer__services--mobile]="isMobile">
    <div [class.none-login-footer__service]="!isMobile" [class.none-login-footer__service--mobile]="isMobile">
      <a href="https://spready.jp">
        <img src="https://pex-static.s3-ap-northeast-1.amazonaws.com/lp/footer_spready.png" alt="＼ あなたにしかつくれない出会いが、世界を変える ／社外とのコラボレーションなら Spready(スプレディ)">
      </a>
    </div>
    <div [class.none-login-footer__service]="!isMobile" [class.none-login-footer__service--mobile]="isMobile">
      <a href="https://profiee.com">
        <img src="https://pex-static.s3-ap-northeast-1.amazonaws.com/lp/footer_profiee.png" alt="＼ オンラインコミュニケーションに最適 ／自分らしいプロフィール作成なら Profiee(プロフィー)">
      </a>
    </div>
  </div>
  <div class="none-login-footer__footer" [class.none-login-footer__footer--mobile]="isMobile">
    <div class="none-login-footer__links">
      <a href="https://spready.co.jp/" target="_blank">運営会社</a>
      <a href="/page/terms" target="_blank">利用規約</a>
      <a href="/page/policy" target="_blank">プライバシーポリシー</a>
      <a href="/page/commercial" target="_blank">特定商取引法に基づく表記</a>
      <a href="https://twitter.com/profieeteams"><img src="https://pex-static.s3-ap-northeast-1.amazonaws.com/lp/twitter_logo.svg" alt="twitter" class="sns-icon"></a>
      <a href="https://www.facebook.com/profieeteams"><img src="https://pex-static.s3-ap-northeast-1.amazonaws.com/lp/facebook_logo.svg" alt="facebook" class="sns-icon"></a>
      <a href="https://note.com/profieeteams"><img src="https://pex-static.s3-ap-northeast-1.amazonaws.com/lp/note_logo.svg" alt="note" class="sns-icon"></a>
    </div>

    <div class="none-login-footer__logo" [class.none-login-footer__logo--mobile]="isMobile">
      <img src="https://pex-static.s3-ap-northeast-1.amazonaws.com/lp/logo-wvg-white.svg" alt="ProfieeTeams(プロフィーチームズ)">
    </div>
  </div>
</div>
